/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Document from '../model/Document';
import DocumentType from '../model/DocumentType';
import Error from '../model/Error';

/**
* AccountSecretaryStudentDocuments service.
* @module api/AccountSecretaryStudentDocumentsApi
* @version 1.0.0
*/
export default class AccountSecretaryStudentDocumentsApi {

    /**
    * Constructs a new AccountSecretaryStudentDocumentsApi. 
    * @alias module:api/AccountSecretaryStudentDocumentsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Downloads the document for the student
     * Downloads the document for the student given
     * @param {Number} studentId 
     * @param {Number} docId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link File} and HTTP response
     */
    downloadSecretaryStudentDocumentWithHttpInfo(studentId, docId) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling downloadSecretaryStudentDocument");
      }
      // verify the required parameter 'docId' is set
      if (docId === undefined || docId === null) {
        throw new Error("Missing the required parameter 'docId' when calling downloadSecretaryStudentDocument");
      }

      let pathParams = {
        'studentId': studentId,
        'docId': docId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/octet-stream', 'application/json'];
      let returnType = File;
      return this.apiClient.callApi(
        '/account/secretary/student-documents/student/{studentId}/documents/{docId}/download', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Downloads the document for the student
     * Downloads the document for the student given
     * @param {Number} studentId 
     * @param {Number} docId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link File}
     */
    downloadSecretaryStudentDocument(studentId, docId) {
      return this.downloadSecretaryStudentDocumentWithHttpInfo(studentId, docId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get student document details
     * Get details of a specific student document.
     * @param {Number} studentId 
     * @param {Number} docId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Document} and HTTP response
     */
    getSecretaryStudentDocumentByIdWithHttpInfo(studentId, docId) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling getSecretaryStudentDocumentById");
      }
      // verify the required parameter 'docId' is set
      if (docId === undefined || docId === null) {
        throw new Error("Missing the required parameter 'docId' when calling getSecretaryStudentDocumentById");
      }

      let pathParams = {
        'studentId': studentId,
        'docId': docId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Document;
      return this.apiClient.callApi(
        '/account/secretary/student-documents/student/{studentId}/documents/{docId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get student document details
     * Get details of a specific student document.
     * @param {Number} studentId 
     * @param {Number} docId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Document}
     */
    getSecretaryStudentDocumentById(studentId, docId) {
      return this.getSecretaryStudentDocumentByIdWithHttpInfo(studentId, docId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get the document types list
     * Get the document types list visible for the student.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/DocumentType>} and HTTP response
     */
    getSecretaryStudentDocumentTypesWithHttpInfo() {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [DocumentType];
      return this.apiClient.callApi(
        '/account/secretary/student-documents/document-types', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get the document types list
     * Get the document types list visible for the student.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/DocumentType>}
     */
    getSecretaryStudentDocumentTypes() {
      return this.getSecretaryStudentDocumentTypesWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get the documents list for the student
     * Get the documents list that student previously upload from MyAccount
     * @param {Number} studentId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Document>} and HTTP response
     */
    getSecretaryStudentDocumentsWithHttpInfo(studentId) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling getSecretaryStudentDocuments");
      }

      let pathParams = {
        'studentId': studentId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [Document];
      return this.apiClient.callApi(
        '/account/secretary/student-documents/student/{studentId}/documents', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get the documents list for the student
     * Get the documents list that student previously upload from MyAccount
     * @param {Number} studentId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Document>}
     */
    getSecretaryStudentDocuments(studentId) {
      return this.getSecretaryStudentDocumentsWithHttpInfo(studentId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Upload student document
     * Uploads a student document
     * @param {Number} studentId 
     * @param {Number} documentTypeId 
     * @param {File} file 
     * @param {Object} opts Optional parameters
     * @param {String} opts.comment 
     * @param {Number} opts.academicProgramId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Document} and HTTP response
     */
    uploadSecretaryStudentDocumentWithHttpInfo(studentId, documentTypeId, file, opts) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling uploadSecretaryStudentDocument");
      }
      // verify the required parameter 'documentTypeId' is set
      if (documentTypeId === undefined || documentTypeId === null) {
        throw new Error("Missing the required parameter 'documentTypeId' when calling uploadSecretaryStudentDocument");
      }
      // verify the required parameter 'file' is set
      if (file === undefined || file === null) {
        throw new Error("Missing the required parameter 'file' when calling uploadSecretaryStudentDocument");
      }

      let pathParams = {
        'studentId': studentId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'comment': opts['comment'],
        'document_type_id': documentTypeId,
        'file': file,
        'academic_program_id': opts['academicProgramId']
      };

      let authNames = [];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = Document;
      return this.apiClient.callApi(
        '/account/secretary/student-documents/student/{studentId}/documents', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Upload student document
     * Uploads a student document
     * @param {Number} studentId 
     * @param {Number} documentTypeId 
     * @param {File} file 
     * @param {Object} opts Optional parameters
     * @param {String} opts.comment 
     * @param {Number} opts.academicProgramId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Document}
     */
    uploadSecretaryStudentDocument(studentId, documentTypeId, file, opts) {
      return this.uploadSecretaryStudentDocumentWithHttpInfo(studentId, documentTypeId, file, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
